import React, { ForwardedRef, forwardRef } from 'react';

import TextAreaSC from './text-area.styled';

type TTextAreaProps = React.InputHTMLAttributes<HTMLTextAreaElement>;

const TextArea = forwardRef(function TextArea(
  props: TTextAreaProps,
  ref: ForwardedRef<HTMLTextAreaElement>,
) {
  return <TextAreaSC ref={ref} style={{ overflow: 'hidden' }} {...props} />;
});

export default TextArea;
